if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        // Ensure elements are present before proceeding
        if (!this.elements.viewer || !this.elements.thumbnails) return;

        // Add event listeners
        this.initializeEventListeners();

        // Remove semantic list role if desktop layout and media query matches
        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      initializeEventListeners() {
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          if (button) {
            button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          }
        });
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement?.dataset?.mediaId;
        if (!mediaId) return;

        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        // Deactivate all media elements
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          this.prependMedia(activeMedia);
        }

        this.preventStickyHeader();
        this.scrollToActiveMedia(activeMedia);

        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition);
        }
      }

      prependMedia(activeMedia) {
        const mediaParent = activeMedia.parentElement;
        if (mediaParent.firstChild !== activeMedia) {
          mediaParent.prepend(activeMedia);
        }

        if (this.elements.thumbnails) {
          const mediaId = activeMedia.dataset.mediaId;
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail) {
            const thumbnailParent = activeThumbnail.parentElement;
            if (thumbnailParent.firstChild !== activeThumbnail) {
              thumbnailParent.prepend(activeThumbnail);
            }
          }
        }

        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }
      }

      scrollToActiveMedia(activeMedia) {
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((button) => {
          button.removeAttribute('aria-current');
        });
        const button = thumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', 'true');
        }

        if (!this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;

        image.onload = () => {
          if (this.elements.liveRegion) {
            this.elements.liveRegion.setAttribute('aria-hidden', 'false');
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', 'true');
            }, 2000);
          }
        };
        image.src = image.src; // Trigger image load
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        if (!this.stickyHeader) {
          this.stickyHeader = document.querySelector('sticky-header');
        }
        if (this.stickyHeader) {
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
      }

      removeListSemantic() {
        if (this.elements.viewer?.slider) {
          this.elements.viewer.slider.setAttribute('role', 'presentation');
          this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    }
  );
}

if (!customElements.get('media-galleryy')) {
  customElements.define(
    'media-galleryy',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatuss"]'),
          viewer: this.querySelector('[id^="GalleryViewerr"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnailss"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        // Ensure elements are present before proceeding
        if (!this.elements.viewer || !this.elements.thumbnails) return;

        // Add event listeners
        this.initializeEventListeners();

        // Remove semantic list role if desktop layout and media query matches
        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      initializeEventListeners() {
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          if (button) {
            button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          }
        });
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement?.dataset?.mediaId;
        if (!mediaId) return;

        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        // Deactivate all media elements
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          this.prependMedia(activeMedia);
        }

        this.preventStickyHeader();
        this.scrollToActiveMedia(activeMedia);

        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition);
        }
      }

      prependMedia(activeMedia) {
        const mediaParent = activeMedia.parentElement;
        if (mediaParent.firstChild !== activeMedia) {
          mediaParent.prepend(activeMedia);
        }

        if (this.elements.thumbnails) {
          const mediaId = activeMedia.dataset.mediaId;
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail) {
            const thumbnailParent = activeThumbnail.parentElement;
            if (thumbnailParent.firstChild !== activeThumbnail) {
              thumbnailParent.prepend(activeThumbnail);
            }
          }
        }

        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }
      }

      scrollToActiveMedia(activeMedia) {
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((button) => {
          button.removeAttribute('aria-current');
        });
        const button = thumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', 'true');
        }

        if (!this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;

        image.onload = () => {
          if (this.elements.liveRegion) {
            this.elements.liveRegion.setAttribute('aria-hidden', 'false');
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', 'true');
            }, 2000);
          }
        };
        image.src = image.src; // Trigger image load
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        if (!this.stickyHeader) {
          this.stickyHeader = document.querySelector('sticky-header');
        }
        if (this.stickyHeader) {
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
      }

      removeListSemantic() {
        if (this.elements.viewer?.slider) {
          this.elements.viewer.slider.setAttribute('role', 'presentation');
          this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    }
  );
}
